import React from "react";
import Section from "../components/primatives/Section";
import SectionHeader from "../components/primatives/SectionHeader";
import TagButton from "../components/primatives/TagButton";
import { FiZap, FiArrowUpCircle } from "react-icons/fi";

class ThankYouPurchase extends React.Component {
  confetti = (e) => {
    e.preventDefault();

    this.props.launchConfetti();
  };

  render() {
    return (
      <Section>
        <SectionHeader>
          <div className="font-extrabold">
            <FiZap /> Power Up!
          </div>
        </SectionHeader>
        <div className="text-sm mb-2">
          Thanks for your purchase. Your credit total has been increased above. <FiArrowUpCircle />
        </div>
        <TagButton onClick={this.confetti}>YAY, more confetti please.</TagButton>
      </Section>
    );
  }
}

export default ThankYouPurchase;
